import React, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';

const isIntersectionObserverExists =
    typeof IntersectionObserver !== 'undefined';

const StickyBar = ({ children }) => {
    const [isSticky, setIsSticky] = useState(false);

    const onElementSticky = ([entry]) => {
        const isIntersectingFromTop =
            entry.intersectionRatio < 1 && entry.intersectionRect.y === 0;

        if (isIntersectingFromTop) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
    };

    const observer = useRef(
        isIntersectionObserverExists &&
            new IntersectionObserver(onElementSticky, { threshold: 1 })
    );
    const topbarNode = useRef(null);

    useEffect(() => {
        isIntersectionObserverExists &&
            observer.current.observe(topbarNode.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div id="topbar"
            ref={topbarNode}
            className={classNames('sticky-wrapper', {
                'is-sticky box-shadow-z4': isSticky
            })}>
            <div className="shadow-effect">
                <div className="floating-top-bar">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default StickyBar;
